namespace $.$$ {

	export class $shm_ba_search_settings extends $.$shm_ba_search_settings {

		description() {
			const case_text = this.search_case_sensitive()
				? 'Регистр учитывается: бот и Бот считаются разными запросами.'
				: 'Регистр не учитывается: бот, Бот и БОТ считаются одним запросом.'

			const mode = this.search_mode()
			if( mode === 'fts' ) return `FTS: ищет по полнотекстовому индексу DuckDB с русским стеммингом. Индекс: create_fts_index(..., stemmer = 'russian', stopwords = 'none', ignore = '[^А-Яа-яЁёA-Za-z0-9]+', strip_accents = 0, lower = 1, overwrite = 1). SQL: fts_main_<table>.match_bm25(source."_ID", lower(query)) IS NOT NULL. Индекс содержит только Заголовок и Текст, поэтому fields не задается. Регистр в FTS-пресете не учитывается.`
			if( mode === 'substring' ) return `Подстрока: ищет точное вхождение внутри слов. SQL: "Заголовок" ${ this.search_case_sensitive() ? 'LIKE' : 'ILIKE' } '%query%' OR "Текст" ${ this.search_case_sensitive() ? 'LIKE' : 'ILIKE' } '%query%'. Найдет бот в работа, зато удобно для частей слов, URL и артикулов. ${ case_text }`
			return ''
		}

	}

}
